export const FOOTER_SEO_CONTENT_CANCERCROWDFUNDING = {
  mainTitle: 'Fundraising for Cancer Patients: A Complete Guide to Raising Funds for Cancer Treatment',
  sections: [
    {
      id: 1,
      heading: '',
      subHeading: 'Crowdfunding for Cancer Patients: Get Financial Help for Cancer Treatment in India',
      desc: `A cancer diagnosis is physically and emotionally devastating, but the financial burden it brings should not cost a life. With rising healthcare expenses in India, many families find themselves unable to afford the life-saving care their loved ones desperately need. When cancer treatments like chemotherapy, surgery, or transplants can cost anywhere from ₹5 Lakh to ₹25 Lakh, families often exhaust their savings.<br/> <p class='desc mt-4'>But there is hope. Through our safe, trusted, and verified crowdfunding platform, thousands of people in India are receiving the financial support they need for cancer patients. Don’t let a lack of funds delay critical medical care. Rely on the power of community.</p><p class='desc'>Start a Cancer Fundraiser today and bridge the gap between treatment and recovery.</p>`,
      children:null,
    },
    {
      id: 2,
      heading: '',
      subHeading: 'What is Cancer Crowdfunding and How Does It Work?',
      desc: `What is cancer crowdfunding? Simply put, it is an online method of raising small amounts of money from a large number of people. If you need financial help for cancer treatment, crowdfunding lets you securely raise donations online without the burden of loans. It relies on community-based donations made effortlessly via digital payments (UPI, debit cards, credit cards, and net banking).</br><p class='desc mt-4'><strong>How Does Cancer Crowdfunding Work? / How to Start a Cancer Crowdfunding Campaign</strong></p>`,
      children: [
        {
          id: 1,
          heading: '',
          desc: `Follow these simple steps to launch your crowdfunding for cancer campaign (takes just 5 minutes):`,
          bullet:false,
          list: [
            {
              id: 1,
              title: `<strong>How online fundraising works:</strong> You set up a page on a medical fundraising website like Ketto, share the patient's story, medical documents, and invite others to contribute.`,
            },
            {
              id: 2,
              title: "<strong>Community-Based Donations:</strong> People who see your appeal, whether they know you or not, can offer a donation for medical treatment.",
            },
            {
              id: 3,
              title: "<strong>Rising Medical Inflation:</strong> Hospital bills in India are growing at nearly 14% every year, meaning that even a well-planned savings account can be wiped out in a single week. This makes it incredibly difficult for middle-class families to keep up with the soaring costs of private hospital treatments.",
            },
            {
              id: 4,
              title: "<strong>The Insurance Gap:</strong> Most health insurance policies in India only cover the basics, leaving a massive \"hidden cost\" for surgeries and specialised care. For a major operation, you are often left to pay the remainder \"out of pocket,\" which can run into lakhs of rupees.",
            },
            {
              id: 5,
              title: "<strong>Emergency Surgeries:</strong> When an accident happens, every second counts. When you need money for medical treatment or an emergency surgery, you don’t have the luxury of time to wait for bank approvals or loan paperwork while your loved one is in the ER.",
            },
            {
              id: 6,
              title: "<strong>Rural vs Urban Divide:</strong> Families from smaller towns often have to travel thousands of miles to big cities for specialised care, adding the high cost of travel and lodging to an already high hospital bill. Medical crowdfunding helps take some of the burden off their shoulders by connecting them with donors who understand their struggle and are ready to help pay for the patient’s medical treatment.",
            },
            {
              id: 7,
              title: "<strong>The Reality:</strong> Stats show that over 55 million Indians fall into poverty every year because of \"out-of-pocket\" medical spending. This is why seeking financial help for medical treatment in India has become a critical necessity for families who want their loved ones to receive the best medical care without draining their savings and resources.",
            }
          ]
        },
        {
          id: 2,
          heading: '',
          desc: `<strong>Safety & Transparency Protocols:</strong>`,
          bullet:true,
          list: [
            {
              id: 1,
              title: "<strong>KYC Process:</strong> We ensure complete transparency through a strict verification process for both the patient’s ID and medical reports."
            },
            {
              id: 2,
              title: "<strong>Payment Security:</strong> All digital donations go through SSL-secured payment gateways."
            },
            {
              id: 3,
              title: "<strong>Transparency:</strong> Donors can see how their donations for cancer treatment are being used through real-time campaign updates."
            }
          ]
        },
      ]
    },
    {
      id: 3,
      heading: '',
      subHeading: 'Why Cancer Fundraising is Important in India',
      desc: `Cancer cases are rising rapidly, yet many families remain financially unprepared. Securing financial aid for cancer patients in India is a critical national requirement due to:`,
      children: [
        {
          bullet:true,
          list: [
            {
              id: 1,
              title: "<strong>Rising Cancer Cases in India:</strong> The disease is increasingly prevalent, placing a massive burden on families."
            },
            {
              id: 2,
              title: "<strong>High Treatment Costs:</strong> Long-term treatments force middle-class families to quickly exhaust emergency savings."
            },
            {
              id: 3,
              title: "<strong>Limited Insurance Coverage:</strong> Many Indian health insurance policies have strict caps or waiting periods, failing to cover specialized therapies."
            },
            {
              id: 4,
              title: "<strong>High Out-of-Pocket Expenses:</strong> Most medical payments in India are made out-of-pocket, heavily indebting families."
            },
            {
              id: 5,
              title: "<strong>Urban vs Rural Healthcare Gap:</strong> Rural families face the double burden of high medical costs and travel/living expenses when moving to metro cities for treatment."
            },
            {
              id: 6,
              title: "<strong>Emergency Scenarios:</strong> Immediate access to funding for cancer treatment is life-saving when unexpected complications require sudden ICU care."
            }
          ]
        }
      ]
    },
    {
      id: 4,
      heading: '',
      subHeading: 'How Much Does Cancer Treatment Cost in India?',
      desc: `<strong>Cancer Treatment Cost in India</strong><br/> <p class='desc mt-2'>If you are looking to start fundraising for a cancer patient, it helps to set a goal based on standard medical expenses. Below are estimated costs:</p>`,
      children: [
        {
          desc2: '<strong>(Note: Actual costs depend heavily on the hospital, city, and stage of cancer.)</strong>',
          bullet: true,
          list: [
            {
              id: 1,
              title: "<strong>Cost of Chemotherapy in India:</strong> Ranges between ₹50,000 – ₹2,00,000 per cycle, depending on the cancer type and drugs used."
            },
            {
              id: 2,
              title: "<strong>Cost of Radiation Therapy:</strong> Often required for consecutive weeks, costing between ₹1.5 Lakhs to ₹3 Lakhs in total."
            },
            {
              id: 3,
              title: "<strong>Cost of Cancer Surgery:</strong> Major tumor removal surgeries typically range from ₹2 Lakhs to ₹10 Lakhs, based on the complexity and the hospital."
            },
            {
              id: 4,
              title: "<strong>Bone Marrow Transplant (BMT) Cost:</strong> Vital for blood cancers, a BMT requires significant hospital care, generally costing ₹15 Lakhs – ₹40 Lakhs."
            }
          ]
        }
      ]
    },
    {
      id: 5,
      heading: '',
      subHeading: 'Who Can Start a Cancer Fundraising Campaign?',
      desc: `Ketto  makes crowdfunding for cancer patients simple. With no technical skills required and a fast approval process, anyone closely involved in the patient's care can initiate a campaign:`,
      children: [
        {
          id: 1,
          heading: '',
          desc2: 'Our dedicated support team provides personalized assistance to help you optimize your fundraiser!',
          bullet: false,
          list: [
            {
              id: 1,
              title: "<strong>Patients:</strong> If you are undergoing treatment and need immediate funds."
            },
            {
              id: 2,
              title: "<strong>Family Members:</strong> Parents, siblings, and spouses who want to financially support the patient."
            },
            {
              id: 3,
              title: "<strong>Friends & Colleagues:</strong> Helping shoulder the burden for a loved one."
            },
            {
              id: 4,
              title: "<strong>NGOs:</strong> Any verified NGO helping cancer patients can run large-scale appeals."
            },
            {
              id: 5,
              title: "<strong>Hospitals/Doctors:</strong> Raising funds for critical cases that have exhausted all options."
            }
          ],
        },
      ]
    },
    {
      id: 6,
      heading: '',
      subHeading: 'Types of Cancer That Commonly Require Crowdfunding in India',
      desc: `Due to prolonged treatment timelines, high medical bills, or the need to raise money for targeted therapies, certain diagnoses most often require public assistance. Types of Cancer Cases Commonly Funded:`,
      children: [
        {
          id: 1,
          heading: '',
          bullet: true,
          list: [
            {
              id: 1,
              title: "Breast cancer (Starting a breast cancer crowdfunding campaign is highly common to cover mastectomy and radiation)."
            },
            {
              id: 2,
              title: "Blood cancer / Leukemia (Often requires high-cost BMT)."
            },
            {
              id: 3,
              title: "Lung cancer (We frequently host campaigns, such as a lung cancer crowdfunding campaign or a lung cancer crowdfunding Mumbai campaign, to fund targeted therapies)."
            },
            {
              id: 4,
              title: "Oral cancer (Highly prevalent in India; reconstructive surgery needed)."
            },
            {
              id: 5,
              title: "Cervical cancer"
            },
            {
              id: 6,
              title: "Pediatric cancers (Raising money to save children with sudden tumor diagnoses)."
            },
            {
              id: 7,
              title: "Note: Funds can also be geared toward general wellness support, awareness, or life-saving treatment."
            }
          ],
        },
      ]
    },
    {
      id: 7,
      heading: '',
      subHeading: 'Why Choose Our Platform for Cancer Crowdfunding?',
      desc: `We act as your dedicated safety net, bringing <a href='https://www.ketto.org/blog/is-ketto-genuine' target=\"_blank\"> transparency and trust</a> to every rupee raised. Here’s why we are a top choice to gather your cancer fund:`,
      children: [
        {
          id: 1,
          heading: '',
          bullet: true,
          desc2: 'With genuine compassion backing our technology, we bring emotional security to those battling their darkest hours.',
          list: [
            {
              id: 1,
              title: "<strong>Secure Payment Gateway:</strong> Accepts multi-currency and global payments safely."
            },
            {
              id: 2,
              title: "<strong>Tax Benefits:</strong> Donors may receive 80G tax exemptions (if contributing to registered NGO/applicable campaigns), boosting donor intent."
            },
            {
              id: 3,
              title: "<strong>Real-time Donation Tracking:</strong> Monitor who donates exactly when it happens."
            },
            {
              id: 4,
              title: "<strong>Fast Withdrawal:</strong> Seamless and quick transfer of funds directly for hospital clearance."
            },
            {
              id: 5,
              title: "<strong>Dedicated Support Team:</strong> Campaign managers guide you step-by-step to get cancer treatment financial help in India."
            },
            {
              id: 6,
              title: "<strong>Zero Hidden Charges:</strong> Highly transparent pricing, so the patient receives maximum help."
            }
          ],
        },
      ]
    },
    {
      id: 8,
      heading: '',
      subHeading: 'Tips to Create a Successful Cancer Fundraising Campaign',
      desc: ``,
      children: [
        {
          bullet: true,
          id: 1,
          heading: '',
          list: [
            {
              id: 1,
              title: "<strong>Tell a Genuine Story:</strong> Be heartfelt, transparent, and honest about your financial distress and patient detail."
            },
            {
              id: 2,
              title: "<strong>Upload Clear Medical Documents:</strong> High-quality images of diagnosis reports build strong donor trust."
            },
            {
              id: 3,
              title: "<strong>Use Real Photos & Videos:</strong> Heart-touching pictures of the patient dramatically boost shares and support."
            },
            {
              id: 4,
              title: "<strong>Share Regular Updates:</strong> Post post-chemo updates or recovery messages to keep your donor community emotionally connected."
            },
            {
              id: 5,
              title: "<strong>Promote on WhatsApp & Social Media:</strong> Don’t underestimate your inner circle. Sharing actively drives more external financial help for cancer patients."
            },
            {
              id: 6,
              title: "<strong>Set a Realistic Fundraising Goal:</strong> Based purely on precise hospital cost estimates."
            }
          ],
        },
      ]
    },
    {
      id: 9,
      heading: '',
      subHeading: 'Frequently Asked Questions About Medical Crowdfunding',
      desc: ``,
      children: [
        {
          id: 1,
          heading: "1. Is cancer crowdfunding legal in India?",
          desc: "Yes, it is entirely legal. Registered platforms like Ketto comply with strict financial regulations to facilitate community-funded medical emergencies."
        },
        {
          id: 2,
          heading: "2. How long does it take to raise funds for cancer treatment?",
          desc: "With the right outreach and authentic storytelling, most fundraising for a cancer patient achieves a substantial amount within 7 to 20 days."
        },
        {
          id: 3,
          heading: "3. Are donations tax-deductible?",
          desc: "Yes, if the funds are being directed through registered medical NGOs carrying an 80G certificate, donors will receive tax exemptions."
        },
        {
          id: 4,
          heading: "4. Can I withdraw funds anytime?",
          desc: "Yes. You can initiate regular withdrawals to pay interim hospital bills as treatment stages progress."
        },
        {
          id: 5,
          heading: "5. Is there any platform fee?",
          desc: "We prioritize patient care over profits. Any fees (like payment gateway costs) are kept entirely transparent with <a href='https://www.ketto.org/support/plans-and-pricing.php' target=\"_blank\">0 hidden platform cuts </a> on specific tip-based campaigns."
        },
        {
          id: 6,
          heading: "6. What documents are required?",
          desc: "A valid Govt ID of the patient/campaigner, a doctor’s letter confirming the disease, hospital bill estimates, and valid bank account details for verification."
        },
        {
          id: 7,
          heading: "7. How to get financial help for cancer patients in India?",
          desc: "Starting an online crowdfunding campaign, checking state health grants (like the Chief Minister's Relief Fund), or connecting with verified NGOs are the fastest ways."
        },
        {
          id: 8,
          heading: "8. Can I get free grant money for cancer patients?",
          desc: "While \"free grant money for cancer patients\" exists via some government schemes (like Ayushman Bharat) or big charities, online crowdfunding for cancer treatment acts as a faster, more reliable source to generate immediate \"free\" communal grant funds that do not need to be repaid."
        }
      ]
    },
    {
      id: 10,
      heading: '',
      subHeading: 'Start Your Cancer Fundraiser Today',
      desc: `Life shouldn't have to wait. If someone you love is waiting for life - saving surgery, chemotherapy, or medical support, do not delay their treatment due to financial fear. Every moment and every share matters. <a href=\"https://www.ketto.org/new/crowdfunding?saf_source=footer_seo_cancer\" target=\"_blank\"> Starting a campaign </a> takes just 5 minutes with our 100% online, hassle- free process.Get the financial power to say YES to survival today!`
    }
  ],
  searches: {
    data: `<a href="https://www.ketto.org/cause/medical-fundraising">Medical Crowdfunding </a> |
        <a href="https://www.ketto.org/blog/best-cancer-hospitals-in-india"> Best Cancer Hospitals In India </a> |
        <a href="https://www.ketto.org/blog/free-cancer-treatment-in-india"> Free Cancer Treatment In India </a>|
        <a href="https://www.ketto.org/blog/social-impact-plan-from-ketto-is-taking-fundraising-to-the-next-level"> Social Impact Plan (SIP) </a>|
        <a href="https://www.ketto.org/blog/individual-fundraising-ideas-meaning"> How to Raise Funds </a>|
        <a href="https://www.ketto.org/blog/what-are-the-types-of-crowdfunding-in-india">Types of Crowdfunding </a> |
        <a href="https://www.ketto.org/cause/cancer-crowdfunding"> Raise Contribution for Cancer Treatment </a> |
        <a href="https://www.ketto.org/blog/cancer-crowdfunding-5-ways-to-raise-money-for-kids-with-cancer"> Raise Money for Kids with Cancer </a>`
  }

};
